import Button from 'components/Button';
import TooltipWrapper from 'components/Tooltip';
import {FC, useState} from 'react';
import {useBackend} from 'state/backend';
import {c} from 'ttag';

import {BackendData} from '../../types';
import ApprovalFlowForm from '../ApprovalFlowForm';

const ModalFlowCreate: FC = () => {
    const {data} = useBackend<BackendData>();
    const [open, setOpen] = useState(false);
    return (
        <>
            <TooltipWrapper
                message={data.permissions.canCreateApproval.failureReason}
            >
                <Button
                    data-testid="create-approval-flow"
                    disabled={!data.permissions.canCreateApproval.allowed}
                    onClick={() => setOpen(true)}
                    size="sm"
                >
                    {c('approval-settings').t`Create Approval Flow`}
                </Button>
            </TooltipWrapper>
            <ApprovalFlowForm
                actionType="create"
                open={open}
                setOpen={setOpen}
            />
        </>
    );
};

export default ModalFlowCreate;
